import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function FactorInput({
    value,
    min,
    max,
    onChange,
}: {
    value: number;
    min: number;
    max: number;
    onChange: (value: number) => void;
}) {
    const { t } = useTranslation();
    const [raw, setRaw] = useState(String(value));

    // Resync when `value` changes from outside (e.g. a GOÄ code selection applying its
    // default factor) — but not while the user is actively typing, since onChange already
    // keeps `raw`/`value` in lockstep in that case (Number(raw) === value).
    useEffect(() => {
        if (Number(raw) !== value) setRaw(String(value));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const numeric = Number(raw);
    const outOfRange = Number.isNaN(numeric) || numeric < min || numeric > max;
    const rangeLabel = t("invoicePage.factorAllowedRange", { min, max });

    return (
        <div className="factor-input">
            <input
                type="number"
                className={`factor-input__field${outOfRange ? " factor-input__field--error" : ""}`}
                value={raw}
                step={0.1}
                min={min}
                max={max}
                title={rangeLabel}
                onChange={(e) => {
                    setRaw(e.target.value);
                    const n = Number(e.target.value);
                    if (!Number.isNaN(n)) onChange(n);
                }}
                onBlur={() => {
                    let n = Number(raw);
                    if (Number.isNaN(n)) n = min;
                    n = Math.min(max, Math.max(min, n));
                    setRaw(String(n));
                    onChange(n);
                }}
            />
            <span className={`factor-input__hint${outOfRange ? " factor-input__hint--error" : ""}`}>{rangeLabel}</span>
        </div>
    );
}
